export const error = (state = {}, action) => {
  const { error } = action.payload;
  if (!error) {
    return state;
  }
  if (error.modelState) {
    return error.modelState;
  }
  if (error.name === 'ValidationError') {
    return {
      [error.path]: error.errors,
    };
  }
  if (typeof error === 'object' && error.constructor === Object) {
    const entries = Object.entries(error);
    if (
      entries.length > 0 &&
      entries.every(([, value]) => Array.isArray(value))
    ) {
      const transformedError = {};
      Object.keys(error).forEach((key) => {
        const transformedKey = key.replace(
          /^CustomerDetails-/,
          'customerDetails-'
        );
        transformedError[transformedKey] = error[key];
      });
      return transformedError;
    }
  }
  return state;
};
